// extracted by mini-css-extract-plugin
module.exports = {"message":"_2029d2a","infoBoxMs":"_4613ff4"};